import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useSelectionReset } from './selection-reset-functions'
import { useGetCampionatiQuery } from './api-slice'
import {
  setSelectedStagione as setSelectedStagioneAction,
  setSelectedCampionato as setSelectedCampionatoAction,
  setSelectedCategoria as setSelectedCategoriaAction,
  setAvailableGironi,
  setSelectedGirone as setSelectedGironeAction,
  setSelectedTeam as setSelectedTeamAction,
  setSelectedNumeroGara as setSelectedNumeroGaraAction,
  setSelectedProvvedimento as setSelectedProvvedimentoAction,
  setSelectedArbitraggio as setSelectedArbitraggioAction,
  setSelectedPeriodo as setSelectedPeriodoAction,
  setSelectedRitardo as setSelectedRitardoAction,
  setSelectedTessera as setSelectedTesseraAction,
  setSelectedArbitro as setSelectedArbitroAction,
  setSelectedSocieta as setSelectedSocietaAction,
} from '../container/selection'

export const useSelectionSet = () => {
  const selectedCategoria = useSelector(
    state => state.selection.selectedCategoria,
  )

  const { data: campionati } = useGetCampionatiQuery()

  const dispatch = useDispatch()

  const {
    resetSelectedSocieta,
    resetSelectedArbitro,
    resetSelectedTessera,
    resetSelectedPeriodo,
    resetSelectedRitardo,
    resetSelectedArbitraggio,
    resetSelectedProvvedimento,
    resetSelectedNumeroGara,
    resetSelectedTeam,
    resetSelectedGirone,
    resetSelectedCategoria,
    resetSelectedCampionato,
    resetSelectedStagione,
  } = useSelectionReset()

  const setSelectedStagione = useCallback(
    async x => {
      if (x) {
        localStorage.setItem('selectedStagione', JSON.stringify(x))
        dispatch(setSelectedStagioneAction(x))
      } else {
        resetSelectedStagione()
      }
    },
    [dispatch, resetSelectedStagione],
  )

  const setSelectedCampionato = useCallback(
    async x => {
      if (x) {
        localStorage.setItem('selectedCampionato', JSON.stringify(x))
        dispatch(
          setSelectedCampionatoAction({ selectedCampionato: x, campionati }),
        )
        resetSelectedCategoria()
        resetSelectedTeam()
        resetSelectedNumeroGara()
      } else {
        resetSelectedCampionato()
      }
    },
    [
      campionati,
      dispatch,
      resetSelectedCampionato,
      resetSelectedCategoria,
      resetSelectedNumeroGara,
      resetSelectedTeam,
    ],
  )

  const setSelectedCategoria = useCallback(
    async x => {
      if (x) {
        localStorage.setItem('selectedCategoria', JSON.stringify(x))
        dispatch(setSelectedCategoriaAction(x))
        dispatch(setAvailableGironi([]))
        resetSelectedGirone()
        resetSelectedNumeroGara()
      } else {
        resetSelectedCategoria()
      }
    },
    [
      dispatch,
      resetSelectedCategoria,
      resetSelectedGirone,
      resetSelectedNumeroGara,
    ],
  )

  const setSelectedGirone = useCallback(
    async x => {
      if (x) {
        localStorage.setItem('selectedGirone', JSON.stringify(x))
        dispatch(setSelectedGironeAction(x))
        resetSelectedTeam()
        resetSelectedNumeroGara()
      } else {
        resetSelectedGirone()
      }
    },
    [dispatch, resetSelectedGirone, resetSelectedNumeroGara, resetSelectedTeam],
  )

  const setSelectedTeam = useCallback(
    async x => {
      if (x) {
        localStorage.setItem('selectedTeam', JSON.stringify(x))
        dispatch(setSelectedNumeroGaraAction())
        dispatch(setSelectedTeamAction(x))
      } else {
        resetSelectedTeam()
      }
    },
    [dispatch, resetSelectedTeam],
  )

  const setSelectedNumeroGara = useCallback(
    async x => {
      if (x?.numeroGara) {
        if (x.categoria !== selectedCategoria) setSelectedCategoria(x.categoria)
        setSelectedGirone(x.girone)
        dispatch(setSelectedNumeroGaraAction(x.numeroGara))
      } else {
        resetSelectedNumeroGara()
      }
    },
    [
      dispatch,
      resetSelectedNumeroGara,
      selectedCategoria,
      setSelectedCategoria,
      setSelectedGirone,
    ],
  )

  const setSelectedProvvedimento = useCallback(
    async x => {
      if (x) {
        localStorage.setItem('selectedProvvedimento', JSON.stringify(x))
        dispatch(setSelectedProvvedimentoAction(x))
      } else {
        resetSelectedProvvedimento()
      }
    },
    [dispatch, resetSelectedProvvedimento],
  )

  const setSelectedArbitraggio = useCallback(
    async x => {
      if (x) {
        localStorage.setItem('selectedArbitraggio', JSON.stringify(x))
        dispatch(setSelectedArbitraggioAction(x))
      } else {
        resetSelectedArbitraggio()
      }
    },
    [dispatch, resetSelectedArbitraggio],
  )

  const setSelectedPeriodo = useCallback(
    async x => {
      if (x) {
        localStorage.setItem('selectedPeriodo', JSON.stringify(x))
        dispatch(setSelectedPeriodoAction(x))
      } else {
        resetSelectedPeriodo()
      }
    },
    [dispatch, resetSelectedPeriodo],
  )

  const setSelectedRitardo = useCallback(
    async x => {
      if (x) {
        localStorage.setItem('selectedRitardo', JSON.stringify(x))
        dispatch(setSelectedRitardoAction(x))
      } else {
        resetSelectedRitardo()
      }
    },
    [dispatch, resetSelectedRitardo],
  )

  const setSelectedTessera = useCallback(
    async x => {
      if (x) {
        localStorage.setItem('selectedTessera', JSON.stringify(x))
        dispatch(setSelectedTesseraAction(x))
      } else {
        resetSelectedTessera()
      }
    },
    [dispatch, resetSelectedTessera],
  )

  const setSelectedArbitro = useCallback(
    async x => {
      if (x) {
        localStorage.setItem('selectedArbitro', JSON.stringify(x))
        dispatch(setSelectedArbitroAction(x))
      } else {
        resetSelectedArbitro()
      }
    },
    [dispatch, resetSelectedArbitro],
  )

  const setSelectedSocieta = useCallback(
    async x => {
      if (x) {
        localStorage.setItem('selectedSocieta', JSON.stringify(x))
        dispatch(setSelectedSocietaAction(x))
      } else {
        resetSelectedSocieta()
      }
    },
    [dispatch, resetSelectedSocieta],
  )

  return {
    setSelectedStagione,
    setSelectedCampionato,
    setSelectedCategoria,
    setSelectedGirone,
    setSelectedTeam,
    setSelectedNumeroGara,
    setSelectedProvvedimento,
    setSelectedArbitraggio,
    setSelectedPeriodo,
    setSelectedRitardo,
    setSelectedTessera,
    setSelectedArbitro,
    setSelectedSocieta,
  }
}
